<footer class="footer">
  <div class="footer-content">
      <div class="footer-left">
          <ng-container>
            <a *ngIf="logoLinkUrl" [href]="logoLinkUrl" target="_blank" rel="noopener" class="footer-logo-link">
              <img [src]="logoImageUrl" alt="ZUM Connect Logo" class="footer-logo" />
            </a>
            <img *ngIf="!logoLinkUrl" [src]="logoImageUrl" alt="ZUM Connect Logo" class="footer-logo" />
          </ng-container>
          <ng-container *ngIf="supportLogos?.length > 0;">
            <div class="support-logos">
              <a *ngFor="let l of supportLogos" [href]="l.link" target="_blank" rel="noopener" class="support-logo-item">
                <img [src]="l.url" alt="Support Logo" class="support-logo-img" />
              </a>
            </div>
          </ng-container>
          <p class="slogan">{{ tagLine || ('CfHome.Discover' | translate) }}</p>
      </div>
      <div class="footer-right">
        <ul class="footer-links">
          <li><span (click)="navigateToAboutUs($event);closeTooltip()" style="cursor: pointer;">{{'CfHome.AboutUs' | translate}}</span></li>
          <!-- <li><span href="#contact">{{'CfHome.Contact' | translate}}</span></li> -->
          <li><span (click)="navigateToPrivacyPolicy($event);closeTooltip()" href="#privacy" style="cursor: pointer;">{{'CfHome.PrivacyPolicy' | translate}}</span></li>
          <!-- <li><span href="#sitemap">{{'CfHome.SiteMap' | translate}}</span></li> -->
          <li><span (click)="navigateToTermsOfUse($event);closeTooltip()" href="#terms" style="cursor: pointer;">{{'CfHome.TermsOfUse' | translate}}</span></li>
      </ul>
      <ul class="footer-social-media-links">
        <li class="icon-wrapper" *ngFor="let g of groupedLinks" [class.open]="openGroupKey === g.key">
            <ng-container *ngIf="g.links.length === 1; else multiLinks">
              <a [href]="g.links[0]?.link" target="_blank" rel="noopener" [attr.aria-label]="g.name" (click)="closeTooltip()">
                <i-feather [name]="g.icon"></i-feather>
              </a>
            </ng-container>
            <ng-template #multiLinks>
              <span class="icon-trigger" [attr.aria-label]="g.name" tabindex="0" (click)="toggleGroup(g.key); $event.preventDefault(); $event.stopPropagation()">
                <i-feather [name]="g.icon"></i-feather>
              </span>
            </ng-template>
            <div class="icon-popover" *ngIf="g.links.length > 1 && openGroupKey === g.key" (click)="$event.stopPropagation()">
              <ul>
                <li *ngFor="let l of g.links">
                  <a [href]="l.link" target="_blank" rel="noopener" [title]="l.link">{{ getLinkLabel(l.link) }}</a>
                </li>
              </ul>
            </div>
          </li>
      </ul>
      </div>
  </div>
  <div class="footer-copyright">
    <p>Powered by <a [href]="zumConnectPortalUrl" target="_blank" rel="noopener">ZUMConnect</a></p>
  </div>
</footer>
